// web/src/components/FormField.tsx — visible label, validate-on-blur, accessible error (D05).
import { useState } from 'react';

export function FormField({ label, name, type = 'text', required, value, onChange, validate, helper, inputMode, textarea, rows }: {
  label: string; name: string; type?: string; required?: boolean;
  value: string; onChange(v: string): void;
  validate?(v: string): string | null;
  helper?: string; inputMode?: 'text' | 'email' | 'tel' | 'url' | 'numeric' | 'decimal' | 'search';
  textarea?: boolean; rows?: number;
}) {
  const [error, setError] = useState<string | null>(null);
  const onBlur = () => setError(validate ? validate(value) : null);
  const cls = `w-full rounded-md border bg-bg px-3 py-2.5 text-ink placeholder:text-muted/60 ${error ? 'border-danger' : 'border-hair'}`;
  return (
    <div className="flex flex-col gap-1.5">
      <label htmlFor={name} className="text-sm font-medium text-ink">
        {label}{required && <span className="ml-0.5 text-danger">*</span>}
      </label>
      {textarea ? (
        <textarea id={name} name={name} value={value} rows={rows ?? 4}
          onChange={(e) => onChange(e.target.value)} onBlur={onBlur}
          aria-invalid={!!error} className={cls} />
      ) : (
        <input id={name} name={name} type={type} value={value} inputMode={inputMode}
          onChange={(e) => onChange(e.target.value)} onBlur={onBlur}
          aria-invalid={!!error} className={cls} />
      )}
      {error
        ? <p role="alert" className="text-xs text-danger">{error}</p>
        : helper && <p className="text-xs text-muted">{helper}</p>}
    </div>
  );
}
